import earnStores from './earnStores';

export default earnStores;
